<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15 5.89941V13.5996C15 13.9709 14.8568 14.3273 14.6016 14.5898C14.3463 14.8524 13.9997 15 13.6387 15H12.8994V7.73438C12.8993 7.41231 12.6385 7.15141 12.3164 7.15137H3.77148C3.44937 7.15137 3.18856 7.41228 3.18848 7.73438V15H2.36133C2.00034 15 1.6537 14.8524 1.39844 14.5898C1.14324 14.3273 1 13.9709 1 13.5996V5.89941L8 1L15 5.89941ZM11.7334 15H4.35449V8.31738H11.7334V15ZM6.33496 12.2783C6.01285 12.2783 5.75204 12.5392 5.75195 12.8613C5.75195 13.1835 6.01279 13.4443 6.33496 13.4443H9.75293C10.0751 13.4443 10.3359 13.1835 10.3359 12.8613C10.3358 12.5393 10.075 12.2784 9.75293 12.2783H6.33496ZM6.33496 9.71484C6.01285 9.71484 5.75204 9.97576 5.75195 10.2979C5.75195 10.62 6.01279 10.8809 6.33496 10.8809H9.75293C10.0751 10.8808 10.3359 10.62 10.3359 10.2979C10.3358 9.97579 10.075 9.71489 9.75293 9.71484H6.33496Z" fill="currentColor"/>
  </svg>
</template>

<script setup lang="ts">

</script>
